import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

/** Table/list datetime: 2026-06-01 16:03:57 (24-hour) */
export const DATETIME_DISPLAY_FORMAT = "YYYY-MM-DD HH:mm:ss";

/** DatePicker + TimePicker (24-hour) */
export const DATETIME_PICKER_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATETIME_PICKER_SHOW_TIME = { format: "HH:mm:ss" };
export const TIME_PICKER_FORMAT = "HH:mm:ss";

export const formatDate = (dayjsObj, format = "YYYY-MM-DD") => {
  return dayjsObj ? dayjs(dayjsObj).format(format) : dayjsObj;
};

export const formatDateTimeDisplay = (value, fallback = "-") => {
  if (value == null || value === "") return fallback;
  return dayjs(value).format(DATETIME_DISPLAY_FORMAT);
};

export const convertToDayjs = (date, format) => {
  if (!date) return date;
  return format ? dayjs.utc(date, format) : dayjs.utc(date);
};

export const changeFormatDateTime = (date, format = "DD-MM-YYYY") => {
  if (!date) return "-";
  return dayjs.utc(date).format(format);
};
